import { applyVoucher } from '../../services/payment/applyVoucher';

export const serviceList = { applyVoucher };

type ServiceList = typeof serviceList;

export type ServiceListBinded = {
  [K in keyof ServiceList]: OmitThisParameter<ServiceList[K]>
};
